module.exports = __webpack_public_path__ + "static/hero-2d95ebbc8776b97d0f0459c9ab9858c5.png";